export const legTypes = {
    PICKUP: 1,
    DELIVERY: 2,
    ACTIVITY: 3
}